import React, { useRef, useState } from 'react';
import Head from 'next/head';
import Image from 'next/image';
import cn from 'classnames';
import { Modal } from 'antd';
import Layout from 'components/layout';
import style from 'styles/activity/shoulderplan.module.scss';
const IMG_PATH = 'https://testdevcdn.xylink.com/h5/sdk_doc/static/website/shoulder/';
const classroom = [
  {
    desc: '利用云+AI技术\n推进教育信息化变革',
    icon: 'https://devcdn.xylink.com/xylink_website_doc/images/activity/shoulderPlan/pc/icon-01.png',
  },
  {
    desc: '整合技术、教育等\n多方资源打破屏障',
    icon: IMG_PATH + 'e73c7a6d8fcf42d723109d165807d580a8c3232ebe12a8b01541ef42432180d7.png',
  },
  {
    desc: '名师1:1全高清远程授课\n还原授课端',
    icon: 'https://devcdn.xylink.com/xylink_website_doc/images/activity/shoulderPlan/pc/icon-03.png',
  },
  {
    desc: '走进中国边远山区学校\n搭建万间课堂',
    icon: IMG_PATH + '5201ff9a6cce21b1326e173e5f272b5dc8439b177023a68a10c426f274250cae.png',
  },
  {
    desc: '为中国2亿学龄儿童\n创造同一片蓝天',
    icon: 'https://devcdn.xylink.com/xylink_website_doc/images/activity/shoulderPlan/pc/icon-05.png',
  },
];

const project = [
  {
    count: IMG_PATH + '4e4d51944b0f45ca058cdd3fcb1fc194fd39e3ee12bc564693371f1fe846c43e.png',
    date: '2018年9月',
    desc: '肩膀计划将完成6间双师课堂部署',
  },
  {
    count: IMG_PATH + '5ff52c22529c94a23fc7f05ff7cf7a39a590be7e61e99cdc52e039f3bfd9011e.png',
    date: '2018年12月',
    desc: '肩膀计划将完成100间双师课堂部署',
  },
  {
    count: IMG_PATH + 'ca2e6eb4e511d8cf81ba83d64d66fe5a78fc23a6eee134468e74e0d6a13b7a21.png',
    date: '2021年内',
    desc: '肩膀计划将完成900间双师课堂部署',
  },
];
const mp4Url = 'https://devcdn.xylink.com/website/video/xylink-shoulder.mp4';
const ShoulderPlan = () => {
  const [videoVisible, setVideoVisible] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const playVideo = (value: boolean) => {
    if (value) {
      videoRef.current?.play();
    } else {
      videoRef.current?.pause();
    }
    setVideoVisible(value);
  };

  return (
    <Layout>
      <Head>
        <title>『天地之间，肩膀之上』肩膀计划</title>
      </Head>
      <section className={style.banner1}>
        <img src="https://devcdn.xylink.com/xylink_website_doc/images/replace/shoulder/pc/pc-banner-1-font.png" className={cn(style.slogan, 'for-pc')} alt="肩膀计划" />
      </section>
      <section className={style.banner2}>
        <div className={style.context}>
          有一种感动叫难过，亿万孩子同在蓝天下，
          <br className={'for-mobile'} /> 看到的却不是同一片蓝天。
          <br />
          有一种画面不是美，双眸忧郁而迷惑，
          <br className={'for-mobile'} />
          企盼一个肩膀撑起春天的希望。
          <br />
          努力爬上一堵高墙，摘下一颗星星。
          <br />
          孩子们的眼中，是望眼欲穿的渴望。
          <br />
          老师与贫困地区的孩子间有道屏障。
          <br />
          如何打破，让教育真正实现零距离？
        </div>
      </section>
      <section className={style.banner3}>
        <div className={style.bg}>
          <img src="/v2/images/pc-play.png" onClick={() => playVideo(true)} className={style.play} alt="" />
        </div>
      </section>
      <section className={style.banner4}>
        <p>Hello，双师课堂</p>
        <div className={style.container}>
          {classroom.map(item => {
            return (
              <div key={item.desc} className={style.item}>
                <img src={item.icon} alt="" />
                <p dangerouslySetInnerHTML={{ __html: item.desc.replace(/\n/g, '<br/>') }}></p>
              </div>
            );
          })}
        </div>
      </section>
      <section className={style.banner5}>
        <div className={'for-pc'}>
          天地之间，春生，夏长，秋收，冬孕
          <br />
          肩膀之上，责任，担当，有情，有梦
        </div>
        <div className={'for-mobile'}>
          天地之间 <br />
          春生，夏长，秋收，冬孕 <br />
          肩膀之上
          <br />
          责任，担当，有情，有梦
        </div>
      </section>
      <section className={style.banner6}>
        <p>项目进展</p>
        <div className={style.container}>
          {project.map(item => {
            return (
              <div key={item.count} className={style.item}>
                <img src={item.count} className={style.count} alt="" />
                <p className={style.date}>{item.date}</p>
                <p className={style.desc}>{item.desc}</p>
              </div>
            );
          })}
        </div>
      </section>
      <section className={style.banner7}>
        <p>发起方</p>
        <div>
          <img className={'for-pc'} src={IMG_PATH + '6d506f87303ef7841bf1bb87dad288559e93fef294727ec046baabd539977dc1.png'} alt="发起方" />
          <img className={'for-mobile'} src={IMG_PATH + '38f4a9affee8fa6edbdef7b79471884deb932365c01f854d5bff2adb6383c2f6.png'} alt="发起方" />
        </div>
        <p className={style.initiator}>联合发起方</p>
        <img className={'for-pc'} src={IMG_PATH + '139175fdda29337b46ccce9051ea7a52e971b5dd4a0a118720f3bb127d86dffc.png'} alt="联合发起方" />
        <img className={cn(style.mFirst, 'for-mobile')} src={IMG_PATH + '5cfb11eb926aac9b8af15c76ad8651b1688af3eb4415832360af6981d1b691b6.png'} alt="联合发起方" />
        <img className={'for-mobile'} src={IMG_PATH + 'd7dd58958145fe296734ebd5d21bc5993b17c5571e208936e0457cef2a4ec2a6.png'} alt="联合发起方" />
      </section>
      <Modal
        title=" "
        closeIcon={<Image className={style.closeIcon} src="/v2/images/home/live-closer.png" alt="font" layout="fill" />}
        visible={videoVisible}
        centered={true}
        footer={null}
        className={style.videoModal}
        onCancel={() => playVideo(false)}
      >
        <video ref={videoRef} className={style.videoPlayer} controls autoPlay src={mp4Url}>
          您的浏览器不支持video
        </video>
      </Modal>
    </Layout>
  );
};

export default ShoulderPlan;
